<template>
  <div class="modal-card">
    <div class="modal-card-head">
      <h2>{{ Operation }} Group</h2>
    </div>
    <div class="modal-card-body" style="min-height: 450px;">
      <div class="columns">
        <div class="column">
          <b-input placeholder="Name/Title" type="text" v-model="Group.Name"></b-input>
          <br />
          <b-select placeholder="Type" v-model="Group.Type" expanded>
            <option v-for="type in Types">
              {{ type }}
            </option>
          </b-select>
          <br />
          <div v-if="Group.Type == 'Country'">
            <b-autocomplete :data="filteredLogos"
                            placeholder="Select Flag"
                            :open-on-focus="true"
                            field="DisplayName"
                            @typing="filterLogos"
                            @select="option => Group.LogoPath = option.Path">
              <template slot-scope="props">
                <div class="media">
                  <div class="media-left">
                    <img width="32" :src="getFlag(props.option.Path)">
                  </div>
                  <div class="media-content">
                    {{ props.option.DisplayName }}
                  </div>
                </div>
              </template>
            </b-autocomplete>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-card-foot">
      <b-button @click="$parent.close()">Cancel</b-button>
      <b-button class="is-primary" @click="addGroup">{{ Operation }} Group</b-button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      Model: {}
    },
    data() {
      return {
        Name: '',
        Type: '',
        Group: {},
        Logos: [],
        filteredLogos: [],
        Types: [
          "ACC Group",
          "AWG Member",
          "Country"
        ]
      }
    },
    async created() {
      this.Group = JSON.parse(JSON.stringify(this.Model));

      await this.$http.get("api/logo")
        .then(resp => {
          this.Logos = resp.data;
          //resp.data.forEach(logo => {
          //  logo.Logo = require(`${logo.Path}`);
          //  this.Logos.push(logo);
          //})
        }).catch(err => {
          console.error(err);
        });
      this.filteredLogos = this.Logos;
    },
    computed: {
      Operation() {
        if (this.Model.Id)
          return "Edit";
        else
          return "Add";
      }
    },
    methods: {
      filterLogos(text) {
        this.filteredLogos = this.Logos.filter((option) => {
          return option
            .DisplayName
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0;
        })
      },
      getFlag(path) {
        return require('@/assets/images/countryLogos/' + path);
      },
      addGroup() {
        if (this.Group.Name && this.Group.Type) {
          if (this.Operation == "Add") {
            this.$emit('addGroup', this.Group);
          }
          else {
            this.$emit('editGroup', this.Group);
          }
          this.$parent.close();
        } else {
          this.$buefy.notification.open({
            duration: 4000,
            message: "Please fill out all fields",
            type: 'is-danger',
          })
        }
      },
    }
  }
</script>
